var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"fileDom",staticClass:"d-none",attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.uploadHeaderImg}})
}
var staticRenderFns = []

export { render, staticRenderFns }